import React from 'react'

import { Button } from '@mui/material'
import { useCustomerUserRemove } from 'features/customers/hooks/useCustomerUserRemove'
import { useCustomerUsers } from 'features/customers/hooks/useCustomerUsers'
import { useCustomerUserUpsert } from 'features/customers/hooks/useCustomerUserUpsert'
import { isUserAssignedToCustomer } from 'features/customers/utils/users'
import { useSelector } from 'react-redux'
import type { RootState } from 'reducers'

const CustomerAddUserButton = () => {
  const { data: users, isLoading } = useCustomerUsers()
  const userId = useSelector((state: RootState) => state.app.user.id)

  const { mutateAsync: addCustomerUser } = useCustomerUserUpsert()
  const { mutateAsync: removeCustomerUser } = useCustomerUserRemove()

  const isAssigned = isUserAssignedToCustomer(users, userId)

  const handleClick = () => {
    if (!userId) return

    const payload = { userId, roleId: 1 }

    return isAssigned ? removeCustomerUser(payload) : addCustomerUser(payload)
  }

  return (
    <Button disabled={isLoading || !userId} onClick={handleClick}>
      {isAssigned ? 'Remove myself' : 'Add myself'}
    </Button>
  )
}

export default CustomerAddUserButton
